export const BACKEND_URL = process.env.BACKEND_URL
export const WEBSOCKETS_URL = process.env.WEBSOCKETS_URL
export const BILLING_SERVICE_URL = process.env.BILLING_SERVICE_URL
export const DATA_URL = process.env.DATA_URL
export const KOTI_API_URL = process.env.KOTI_API_URL
export const KOTI_WEB_URL = process.env.KOTI_WEB_URL
export const TAX_URL = process.env.TAX_URL
export const FORMS_URL = process.env.FORMS_URL

export const AZURE_APP_INSIGHTS = process.env.AZURE_APP_INSIGHTS
export const FRESH_CHAT_TOKEN = process.env.FRESH_CHAT_TOKEN
export const FRESHCHAT_SITE_ID = process.env.FRESHCHAT_SITE_ID || 'CUBIT_AUDIT'
export const GOOGLE_MAP_KEY = process.env.GOOGLE_MAP_KEY
export const MAPBOX_TOKEN = process.env.MAPBOX_TOKEN
export const LIMITED_RESTART_URL = process.env.LIMITED_RESTART_URL
